var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLaptop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 33,
    viewBox: "0 0 46 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.744.749a3.16 3.16 0 0 0-3.163 3.163v21.395c0 .632.484 1.116 1.117 1.116.632 0 1.116-.484 1.116-1.116V3.912c0-.521.41-.93.93-.93h30.512c.52 0 .93.409.93.93v24H28.58c-.633 0-1.116.483-1.116 1.116h-8.93c0-.633-.484-1.116-1.117-1.116H1.977c-.633 0-1.116.483-1.116 1.116v.558a3.16 3.16 0 0 0 3.162 3.163h37.953a3.16 3.16 0 0 0 3.163-3.163v-.558c0-.633-.483-1.116-1.116-1.116h-2.605v-24A3.16 3.16 0 0 0 38.257.749H7.744zM23 4.098a1.116 1.116 0 1 0 0 2.232 1.116 1.116 0 0 0 0-2.232z",
    fill: "#E20074"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLaptop);
export default __webpack_public_path__ + "static/media/laptop.66b0c0b8ac567e3fb68f1cd6563a8201.svg";
export { ForwardRef as ReactComponent };